import BackDropComponent from "@/components/BackDrop";
import { fetchEarlyCodChargesRequest, fetchIvrNdrConfirmationChargesRequest, fetchIvrORDERConfirmationChargesRequest, fetchOTPverifiedDeliveryChargesRequest, fetchRiskScoreChargesRequest, fetchWhatsappChargesRequest, fetchWhatsappConfirmationChargesRequest, fetchWhatsappNdrVerificationChargesRequest, updateEarlyCodChargesRequest, updateRiskScoreChargesRequest, updateRiskScoreChargesReset, } from "@/redux/actions";
import { Box, Button, Divider, Grid, InputAdornment, OutlinedInput, Tooltip, Typography, } from "@mui/material";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import PhoneInTalkOutlinedIcon from "@mui/icons-material/PhoneInTalkOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import DateRangeOutlinedIcon from "@mui/icons-material/DateRangeOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { enqueueSnackbar } from "notistack";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { config } from "../../../config";
const chargeDays = ["D+1", "D+2", "D+3", "D+4", "D+5", "D+6"];
// Progressive amber → deep-orange for settlement cycle badges
const COD_PALETTE = [
    { label: "#C47B25", bg: "rgba(244,162,97,0.13)", ring: "rgba(244,162,97,0.32)" },
    { label: "#B56D1C", bg: "rgba(240,148,75,0.13)", ring: "rgba(240,148,75,0.32)" },
    { label: "#A65F15", bg: "rgba(235,132,55,0.13)", ring: "rgba(235,132,55,0.32)" },
    { label: "#97510E", bg: "rgba(229,115,37,0.13)", ring: "rgba(229,115,37,0.32)" },
    { label: "#884307", bg: "rgba(222,98,21,0.13)", ring: "rgba(222,98,21,0.32)" },
    { label: "#793600", bg: "rgba(214,80,6,0.13)", ring: "rgba(214,80,6,0.32)" },
];
const COD_LABELS = [
    { title: "Next-day remittance", hint: "Fastest cycle — collect on D, remit on D+1" },
    { title: "2-day settlement", hint: "COD collected on D, remitted on D+2" },
    { title: "3-day settlement", hint: "COD collected on D, remitted on D+3" },
    { title: "4-day settlement", hint: "COD collected on D, remitted on D+4" },
    { title: "5-day settlement", hint: "COD collected on D, remitted on D+5" },
    { title: "Standard settlement", hint: "COD collected on D, remitted on D+6" },
];
const VasChargesForm = ({ tenantId }) => {
    const dispatch = useDispatch();
    const primaryColor = config.theme.primaryColor;
    const [isBackOpenOpen, setIsBackOpenOpen] = React.useState(false);
    const [riskScoreCharges, setRiskScoreCharges] = React.useState("");
    const [ndrIVRCharges, setNdrIVRCharges] = React.useState("");
    const [orderIVRCharges, setOrderIVRCharges] = React.useState("");
    const [OTPVerifiedDeliveryCharges, setOTPVerifiedDeliveryCharges] = React.useState("");
    const [earlyCODCharges, setEarlyCODCharges] = React.useState([]);
    const [whatsappCharges, setWhatsappCharges] = React.useState("");
    const [whatsappConfirmationCharges, setWhatsappConfirmationCharges] = React.useState("");
    const [whatsappNdrVerificationCharges, setWhatsappNdrVerificationCharges] = React.useState("");
    const [selectedVASservice, setSelectedVASservice] = React.useState("");
    const getRiskScoreChargesState = useSelector((s) => s.getRiskScoreChargesReducer);
    const getWhatsappChargesState = useSelector((s) => s.getWhatsappChargesReducer);
    const getWhatsappConfirmationChargesState = useSelector((s) => s.getWhatsappConfirmationChargesReducer);
    const getWhatsappNdrVerificationChargesState = useSelector((s) => s.getWhatsappNdrVerificationChargesReducer);
    const getIVRNdrVerificationChargesState = useSelector((s) => s.getIVRNdrChargesReducer);
    const getIVROrderVerificationChargesState = useSelector((s) => s.getIVRORDERChargesReducer);
    const getOTPverifiedDeliveryChargesState = useSelector((s) => s.getOTPverifiedDeliveryChargesReducer);
    const getEarlyCODChargesState = useSelector((s) => s.getEarlyCODChargesReducer);
    const updateChargesState = useSelector((s) => s.updateRiskScoreChargesReducer);
    const updateEarlyCODChargesState = useSelector((s) => s.updateEarlyCODChargesReducer);
    React.useEffect(() => {
        if (tenantId) {
            dispatch(fetchRiskScoreChargesRequest({ tenantId, vasService: "risk_score", countryCode: "in" }));
            dispatch(fetchWhatsappChargesRequest({ tenantId, vasService: "whatsapp_tracking", countryCode: "in" }));
            dispatch(fetchIvrNdrConfirmationChargesRequest({ tenantId, vasService: "ivr_ndr_confirmation", countryCode: "in" }));
            dispatch(fetchIvrORDERConfirmationChargesRequest({ tenantId, vasService: "ivr_order_verification", countryCode: "in" }));
            dispatch(fetchWhatsappConfirmationChargesRequest({ tenantId, vasService: "whatsapp_order_verification", countryCode: "in" }));
            dispatch(fetchWhatsappNdrVerificationChargesRequest({ tenantId, vasService: "whatsapp_ndr_confirmation", countryCode: "in" }));
            dispatch(fetchOTPverifiedDeliveryChargesRequest({ tenantId, vasService: "otp_verified_delivery", countryCode: "in" }));
            dispatch(fetchEarlyCodChargesRequest({ tenantId, countryCode: "in" }));
        }
    }, [tenantId]);
    React.useEffect(() => {
        var _a;
        if (getRiskScoreChargesState.data) {
            const v = (_a = getRiskScoreChargesState.data) === null || _a === void 0 ? void 0 : _a.baseCharge;
            setRiskScoreCharges(typeof v === "number" ? v.toFixed(2) : "");
        }
        else if (getRiskScoreChargesState.error)
            enqueueSnackbar(getRiskScoreChargesState.error, { variant: "error" });
    }, [getRiskScoreChargesState]);
    React.useEffect(() => {
        if (getEarlyCODChargesState.data)
            setEarlyCODCharges(getEarlyCODChargesState.data.map((v) => v.toString()));
        else if (getEarlyCODChargesState.error)
            enqueueSnackbar(getEarlyCODChargesState.error, { variant: "error" });
    }, [getEarlyCODChargesState]);
    React.useEffect(() => {
        var _a;
        if (getWhatsappChargesState.data) {
            const v = (_a = getWhatsappChargesState.data) === null || _a === void 0 ? void 0 : _a.baseCharge;
            setWhatsappCharges(typeof v === "number" ? v.toFixed(2) : "");
        }
        else if (getWhatsappChargesState.error)
            enqueueSnackbar(getWhatsappChargesState.error, { variant: "error" });
    }, [getWhatsappChargesState]);
    React.useEffect(() => {
        var _a;
        if (getWhatsappConfirmationChargesState.data) {
            const v = (_a = getWhatsappConfirmationChargesState.data) === null || _a === void 0 ? void 0 : _a.baseCharge;
            setWhatsappConfirmationCharges(typeof v === "number" ? v.toFixed(2) : "");
        }
        else if (getWhatsappConfirmationChargesState.error)
            enqueueSnackbar(getWhatsappConfirmationChargesState.error, { variant: "error" });
    }, [getWhatsappConfirmationChargesState]);
    React.useEffect(() => {
        var _a;
        if (getOTPverifiedDeliveryChargesState.data) {
            const v = (_a = getOTPverifiedDeliveryChargesState.data) === null || _a === void 0 ? void 0 : _a.baseCharge;
            setOTPVerifiedDeliveryCharges(typeof v === "number" ? v.toFixed(2) : "");
        }
        else if (getOTPverifiedDeliveryChargesState.error)
            enqueueSnackbar(getOTPverifiedDeliveryChargesState.error, { variant: "error" });
    }, [getOTPverifiedDeliveryChargesState]);
    React.useEffect(() => {
        var _a;
        if (getWhatsappNdrVerificationChargesState.data) {
            const v = (_a = getWhatsappNdrVerificationChargesState.data) === null || _a === void 0 ? void 0 : _a.baseCharge;
            setWhatsappNdrVerificationCharges(typeof v === "number" ? v.toFixed(2) : "");
        }
        else if (getWhatsappNdrVerificationChargesState.error)
            enqueueSnackbar(getWhatsappNdrVerificationChargesState.error, { variant: "error" });
    }, [getWhatsappNdrVerificationChargesState]);
    React.useEffect(() => {
        var _a;
        if (getIVRNdrVerificationChargesState.data) {
            const v = (_a = getIVRNdrVerificationChargesState.data) === null || _a === void 0 ? void 0 : _a.baseCharge;
            setNdrIVRCharges(typeof v === "number" ? v.toFixed(2) : "");
        }
        else if (getIVRNdrVerificationChargesState.error)
            enqueueSnackbar(getIVRNdrVerificationChargesState.error, { variant: "error" });
    }, [getIVRNdrVerificationChargesState]);
    React.useEffect(() => {
        var _a;
        if (getIVROrderVerificationChargesState.data) {
            const v = (_a = getIVROrderVerificationChargesState.data) === null || _a === void 0 ? void 0 : _a.baseCharge;
            setOrderIVRCharges(typeof v === "number" ? v.toFixed(2) : "");
        }
        else if (getIVROrderVerificationChargesState.error)
            enqueueSnackbar(getIVROrderVerificationChargesState.error, { variant: "error" });
    }, [getIVROrderVerificationChargesState]);
    const handleSaveCharges = (vasService) => {
        setIsBackOpenOpen(true);
        setSelectedVASservice(vasService);
        dispatch(updateRiskScoreChargesRequest({
            tenantId,
            vasService,
            countryCode: "in",
            baseCharge: vasService === "risk_score" ? Number(riskScoreCharges)
                : vasService === "whatsapp_tracking" ? Number(whatsappCharges)
                    : vasService === "whatsapp_order_verification" ? Number(whatsappConfirmationCharges)
                        : vasService === "whatsapp_ndr_confirmation" ? Number(whatsappNdrVerificationCharges)
                            : vasService === "ivr_ndr_confirmation" ? Number(ndrIVRCharges)
                                : vasService === "ivr_order_verification" ? Number(orderIVRCharges)
                                    : vasService === "otp_verified_delivery" ? Number(OTPVerifiedDeliveryCharges)
                                        : "",
        }));
    };
    React.useEffect(() => {
        if (updateChargesState.data) {
            const label = selectedVASservice === "risk_score" ? "Risk score"
                : selectedVASservice === "whatsapp_tracking" ? "WhatsApp tracking"
                    : selectedVASservice === "whatsapp_order_verification" ? "WhatsApp order confirmation"
                        : selectedVASservice === "whatsapp_ndr_confirmation" ? "WhatsApp NDR verification"
                            : selectedVASservice === "ivr_ndr_confirmation" ? "IVR NDR confirmation"
                                : selectedVASservice === "ivr_order_verification" ? "IVR order verification"
                                    : selectedVASservice === "otp_verified_delivery" ? "OTP verified delivery"
                                        : "";
            enqueueSnackbar(`${label} charges updated successfully!`, { variant: "success" });
            dispatch(updateRiskScoreChargesReset());
            setIsBackOpenOpen(false);
        }
        else if (updateChargesState.error) {
            enqueueSnackbar(updateChargesState.error, { variant: "error" });
            dispatch(updateRiskScoreChargesReset());
            setIsBackOpenOpen(false);
        }
    }, [updateChargesState]);
    const handleChargeChange = (index, value) => {
        const updated = [...earlyCODCharges];
        updated[index] = value;
        setEarlyCODCharges(updated);
    };
    const handleSaveEarlyCodCharges = () => {
        setIsBackOpenOpen(true);
        dispatch(updateEarlyCodChargesRequest({ tenantId, earlyCODCharges, countryCode: "in" }));
    };
    React.useEffect(() => {
        if (updateEarlyCODChargesState.data) {
            enqueueSnackbar("Early COD charges updated successfully!", { variant: "success" });
            setIsBackOpenOpen(false);
        }
        else if (updateEarlyCODChargesState.error) {
            enqueueSnackbar(updateEarlyCODChargesState.error, { variant: "error" });
            setIsBackOpenOpen(false);
        }
    }, [updateEarlyCODChargesState]);
    // ─── Computed ────────────────────────────────────────────────────────────────
    const vasValues = [
        riskScoreCharges, OTPVerifiedDeliveryCharges, whatsappCharges,
        whatsappConfirmationCharges, whatsappNdrVerificationCharges,
        ndrIVRCharges, orderIVRCharges,
    ];
    const configuredCount = vasValues.filter(Boolean).length;
    // ─── Design tokens ───────────────────────────────────────────────────────────
    /** Shared outlined-input sx with category-aware accent on focus/hover */
    const inputSx = (accent) => ({
        height: 36,
        fontFamily: "Poppins",
        fontSize: "13px",
        borderRadius: "7px",
        bgcolor: "#fff",
        "& .MuiOutlinedInput-input": { fontFamily: "Poppins", fontSize: "13px", py: 0 },
        "& .MuiOutlinedInput-notchedOutline": { borderColor: "#DFE1E8", transition: "border-color 0.15s" },
        "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: accent },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: accent, borderWidth: "1.5px" },
    });
    /** Contained save button that matches the category accent */
    const saveBtnSx = (accent) => ({
        textTransform: "none",
        minWidth: 72,
        height: 36,
        borderRadius: "7px",
        fontFamily: "Poppins",
        fontSize: "12px",
        fontWeight: 600,
        flexShrink: 0,
        bgcolor: accent,
        color: "#fff",
        letterSpacing: "0.01em",
        boxShadow: `0 1px 6px ${accent}50`,
        "&:hover": { bgcolor: accent, opacity: 0.87, boxShadow: `0 3px 12px ${accent}55` },
        "&:active": { opacity: 0.78 },
    });
    // ─── Sub-components ──────────────────────────────────────────────────────────
    /**
     * Top-border coloured card shell.
     * The 3 px coloured top edge is the primary visual differentiator per category.
     */
    const ServiceCard = ({ accent, iconBg, icon, title, serviceTotal, serviceSet, children }) => (React.createElement(Box, { sx: {
            border: "1px solid #E4E6EE",
            borderTop: `3px solid ${accent}`,
            borderRadius: "10px",
            bgcolor: "#fff",
            overflow: "hidden",
            boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
            transition: "box-shadow 0.18s ease",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            "&:hover": { boxShadow: `0 4px 20px rgba(0,0,0,0.09)` },
        } },
        React.createElement(Box, { sx: {
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                px: 2.5,
                py: 1.75,
                borderBottom: "1px solid #F0F1F6",
            } },
            React.createElement(Box, { sx: {
                    width: 38,
                    height: 38,
                    borderRadius: "9px",
                    bgcolor: iconBg,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                } }, icon),
            React.createElement(Box, { sx: { flex: 1, minWidth: 0 } },
                React.createElement(Typography, { sx: { fontFamily: "Poppins", fontWeight: 700, fontSize: "13.5px", color: "#0F0E17", lineHeight: 1.35 } }, title),
                React.createElement(Typography, { sx: { fontFamily: "Poppins", fontSize: "11px", color: "#9A97A8", mt: 0.15 } },
                    serviceSet,
                    " of ",
                    serviceTotal,
                    " ",
                    serviceSet === serviceTotal ? (React.createElement(Box, { component: "span", sx: { color: "#22C55E", fontWeight: 600 } }, "fully configured")) : serviceSet > 0 ? (React.createElement(Box, { component: "span", sx: { color: accent, fontWeight: 600 } }, "configured")) : ("using defaults"))),
            React.createElement(FiberManualRecordIcon, { sx: {
                    fontSize: 9,
                    color: serviceSet === serviceTotal ? "#22C55E" : serviceSet > 0 ? accent : "#D1D5DB",
                    flexShrink: 0,
                } })),
        React.createElement(Box, { sx: { flex: 1 } }, children)));
    /**
     * A single editable service row within a ServiceCard.
     */
    const ServiceRow = ({ label, description, tooltip, value, onChange, vasService, accent, isLast }) => {
        const isSet = value !== "";
        return (React.createElement(React.Fragment, null,
            React.createElement(Box, { sx: {
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    px: 2.5,
                    py: 2,
                    transition: "background-color 0.13s",
                    "&:hover": { bgcolor: `${accent}07` },
                } },
                React.createElement(Box, { sx: { flex: 1, minWidth: 0 } },
                    React.createElement(Box, { sx: { display: "flex", alignItems: "center", gap: 0.75 } },
                        React.createElement(Typography, { sx: { fontFamily: "Poppins", fontWeight: 600, fontSize: "13px", color: "#111827", lineHeight: 1.3 } }, label),
                        React.createElement(Box, { sx: {
                                display: "inline-flex",
                                alignItems: "center",
                                height: 17,
                                px: 0.85,
                                borderRadius: "4px",
                                border: `1px solid ${isSet ? `${accent}35` : "#E5E7EB"}`,
                                bgcolor: isSet ? `${accent}10` : "#F9FAFB",
                            } },
                            React.createElement(Typography, { sx: {
                                    fontFamily: "Poppins",
                                    fontSize: "10px",
                                    fontWeight: 600,
                                    color: isSet ? accent : "#9CA3AF",
                                    lineHeight: 1,
                                } }, isSet ? `₹ ${value}` : "Default")),
                        React.createElement(Tooltip, { title: tooltip, placement: "top", arrow: true },
                            React.createElement(InfoOutlinedIcon, { sx: { fontSize: 13, color: "#D1D5DB", cursor: "pointer" } }))),
                    React.createElement(Typography, { sx: { fontFamily: "Poppins", fontSize: "11.5px", color: "#9CA3AF", mt: 0.3, lineHeight: 1.45 } }, description)),
                React.createElement(Box, { sx: { display: "flex", alignItems: "center", gap: 1.25, flexShrink: 0 } },
                    React.createElement(Box, { sx: { width: 138 } },
                        React.createElement(OutlinedInput, { fullWidth: true, size: "small", value: value, onChange: (e) => onChange(e.target.value), placeholder: "0.00", inputProps: { inputMode: "decimal" }, sx: inputSx(accent), startAdornment: React.createElement(InputAdornment, { position: "start" },
                                React.createElement(Typography, { sx: { fontFamily: "Poppins", fontSize: "13px", color: "#9CA3AF", lineHeight: 1 } }, "\u20B9")) }),
                        React.createElement(Typography, { sx: { fontFamily: "Poppins", fontSize: "9.5px", color: "#C4C7D2", mt: 0.4, textAlign: "center", letterSpacing: "0.02em" } }, "/shipment \u00B7 excl. GST")),
                    React.createElement(Button, { variant: "contained", disableElevation: true, sx: saveBtnSx(accent), onClick: () => handleSaveCharges(vasService) }, "Save"))),
            !isLast && React.createElement(Divider, { sx: { borderColor: "#F3F4F8", mx: 2.5 } })));
    };
    // ─── Render ──────────────────────────────────────────────────────────────────
    return (React.createElement(Box, { sx: { width: "100%", mt: 2 } },
        React.createElement(BackDropComponent, { open: isBackOpenOpen }),
        React.createElement(Box, { sx: {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                mb: 3,
                pb: 2.5,
                borderBottom: "1px solid #EDEEF3",
            } },
            React.createElement(Box, { sx: { display: "flex", alignItems: "flex-start", gap: 1.5 } },
                React.createElement(Box, { sx: { width: 4, height: 30, bgcolor: primaryColor, borderRadius: "3px", mt: 0.25, flexShrink: 0 } }),
                React.createElement(Box, null,
                    React.createElement(Typography, { sx: { fontFamily: "Poppins", fontWeight: 700, fontSize: "18px", color: "#0F0E17", lineHeight: 1.3 } }, "VAS Charges Configuration"),
                    React.createElement(Typography, { sx: { fontFamily: "Poppins", fontSize: "12px", color: "#6B7280", mt: 0.35 } }, "Configure per-shipment fees for all value-added services. Leave a field blank to use the platform default."))),
            React.createElement(Box, { sx: { display: "flex", alignItems: "center", gap: 1, flexShrink: 0 } },
                React.createElement(Box, { sx: {
                        display: "flex",
                        alignItems: "center",
                        gap: 1.5,
                        px: 2,
                        py: 1,
                        border: "1px solid #E4E6EE",
                        borderRadius: "8px",
                        bgcolor: "#F9FAFB",
                    } },
                    React.createElement(Box, { sx: { textAlign: "center" } },
                        React.createElement(Typography, { sx: { fontFamily: "Poppins", fontSize: "10px", fontWeight: 600, color: "#9CA3AF", textTransform: "uppercase", letterSpacing: "0.55px", lineHeight: 1 } }, "Services"),
                        React.createElement(Typography, { sx: { fontFamily: "Poppins", fontWeight: 700, fontSize: "20px", color: "#111827", lineHeight: 1.2 } }, "7")),
                    React.createElement(Box, { sx: { width: 1, height: 32, bgcolor: "#E4E6EE" } }),
                    React.createElement(Box, { sx: { textAlign: "center" } },
                        React.createElement(Typography, { sx: { fontFamily: "Poppins", fontSize: "10px", fontWeight: 600, color: "#9CA3AF", textTransform: "uppercase", letterSpacing: "0.55px", lineHeight: 1 } }, "Set"),
                        React.createElement(Typography, { sx: {
                                fontFamily: "Poppins",
                                fontWeight: 700,
                                fontSize: "20px",
                                color: configuredCount === 7 ? "#22C55E" : configuredCount > 0 ? primaryColor : "#9CA3AF",
                                lineHeight: 1.2,
                            } }, configuredCount))))),
        React.createElement(Grid, { container: true, spacing: 2.5 },
            React.createElement(Grid, { item: true, xs: 12, md: 6 },
                React.createElement(ServiceCard, { accent: "#D54029", iconBg: "rgba(213,64,41,0.09)", icon: React.createElement(ShieldOutlinedIcon, { sx: { fontSize: 20, color: "#D54029" } }), title: "Risk & Fraud Prevention", serviceTotal: 1, serviceSet: riskScoreCharges !== "" ? 1 : 0 },
                    React.createElement(ServiceRow, { label: "Risk Score", description: "Per COD shipment evaluated by the fraud-risk engine", tooltip: "Default \u20B92.00 applied if left blank", value: riskScoreCharges, onChange: setRiskScoreCharges, vasService: "risk_score", accent: "#D54029", isLast: true }))),
            React.createElement(Grid, { item: true, xs: 12, md: 6 },
                React.createElement(ServiceCard, { accent: "#2EC4B6", iconBg: "rgba(46,196,182,0.10)", icon: React.createElement(LocalShippingOutlinedIcon, { sx: { fontSize: 20, color: "#2EC4B6" } }), title: "Delivery Services", serviceTotal: 1, serviceSet: OTPVerifiedDeliveryCharges !== "" ? 1 : 0 },
                    React.createElement(ServiceRow, { label: "OTP Verified Delivery", description: "Charged when delivery is confirmed via one-time password", tooltip: "Default \u20B92.00 applied if left blank", value: OTPVerifiedDeliveryCharges, onChange: setOTPVerifiedDeliveryCharges, vasService: "otp_verified_delivery", accent: "#2EC4B6", isLast: true }))),
            React.createElement(Grid, { item: true, xs: 12, md: 6 },
                React.createElement(ServiceCard, { accent: "#25D366", iconBg: "rgba(37,211,102,0.09)", icon: React.createElement(WhatsAppIcon, { sx: { fontSize: 20, color: "#25D366" } }), title: "WhatsApp Services", serviceTotal: 3, serviceSet: [whatsappCharges, whatsappConfirmationCharges, whatsappNdrVerificationCharges].filter(Boolean).length },
                    React.createElement(ServiceRow, { label: "Shipment Tracking", description: "Proactive status updates delivered via WhatsApp", tooltip: "Default \u20B92.00 applied if left blank", value: whatsappCharges, onChange: setWhatsappCharges, vasService: "whatsapp_tracking", accent: "#25D366" }),
                    React.createElement(ServiceRow, { label: "Order Confirmation", description: "WhatsApp notification sent at order placement", tooltip: "Default \u20B92.00 applied if left blank", value: whatsappConfirmationCharges, onChange: setWhatsappConfirmationCharges, vasService: "whatsapp_order_verification", accent: "#25D366" }),
                    React.createElement(ServiceRow, { label: "NDR Verification", description: "WhatsApp follow-up for non-delivery resolution", tooltip: "Default \u20B93.00 applied if left blank", value: whatsappNdrVerificationCharges, onChange: setWhatsappNdrVerificationCharges, vasService: "whatsapp_ndr_confirmation", accent: "#25D366", isLast: true }))),
            React.createElement(Grid, { item: true, xs: 12, md: 6 },
                React.createElement(ServiceCard, { accent: "#7B61FF", iconBg: "rgba(123,97,255,0.10)", icon: React.createElement(PhoneInTalkOutlinedIcon, { sx: { fontSize: 20, color: "#7B61FF" } }), title: "IVR Services", serviceTotal: 2, serviceSet: [ndrIVRCharges, orderIVRCharges].filter(Boolean).length },
                    React.createElement(ServiceRow, { label: "NDR IVR Confirmation", description: "Automated IVR call for undelivered shipment follow-up", tooltip: "Default \u20B92.00 applied if left blank", value: ndrIVRCharges, onChange: setNdrIVRCharges, vasService: "ivr_ndr_confirmation", accent: "#7B61FF" }),
                    React.createElement(ServiceRow, { label: "Order IVR Verification", description: "Automated IVR call confirming the order at placement", tooltip: "Default \u20B92.00 applied if left blank", value: orderIVRCharges, onChange: setOrderIVRCharges, vasService: "ivr_order_verification", accent: "#7B61FF", isLast: true }))),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(Box, { sx: {
                        border: "1px solid #E4E6EE",
                        borderTop: "3px solid #F4A261",
                        borderRadius: "10px",
                        bgcolor: "#fff",
                        overflow: "hidden",
                        boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
                        transition: "box-shadow 0.18s",
                        "&:hover": { boxShadow: "0 4px 20px rgba(0,0,0,0.08)" },
                    } },
                    React.createElement(Box, { sx: {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            px: 2.5,
                            py: 1.75,
                            borderBottom: "1px solid #F0F1F6",
                        } },
                        React.createElement(Box, { sx: { display: "flex", alignItems: "center", gap: 1.5 } },
                            React.createElement(Box, { sx: {
                                    width: 38,
                                    height: 38,
                                    borderRadius: "9px",
                                    bgcolor: "rgba(244,162,97,0.10)",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    flexShrink: 0,
                                } },
                                React.createElement(DateRangeOutlinedIcon, { sx: { fontSize: 20, color: "#F4A261" } })),
                            React.createElement(Box, null,
                                React.createElement(Typography, { sx: { fontFamily: "Poppins", fontWeight: 700, fontSize: "13.5px", color: "#0F0E17", lineHeight: 1.35 } }, "Early COD Charges"),
                                React.createElement(Typography, { sx: { fontFamily: "Poppins", fontSize: "11px", color: "#9A97A8", mt: 0.15 } }, "% fee on remitted COD amount per settlement cycle \u2014 charged on the gross COD collected"))),
                        React.createElement(Button, { variant: "contained", disableElevation: true, sx: saveBtnSx("#F4A261"), onClick: handleSaveEarlyCodCharges }, "Save all")),
                    React.createElement(Box, { sx: {
                            display: "grid",
                            gridTemplateColumns: "minmax(220px,1fr) 190px 160px 100px",
                            alignItems: "center",
                            px: 2.5,
                            py: 1.1,
                            bgcolor: "#F7F8FA",
                            borderBottom: "1.5px solid #EDEEF3",
                        } }, [
                        "Settlement Cycle",
                        "Charge Rate",
                        "Basis",
                        "Tax",
                    ].map((col) => (React.createElement(Typography, { key: col, sx: {
                            fontFamily: "Poppins",
                            fontWeight: 700,
                            fontSize: "10.5px",
                            color: "#6B7280",
                            textTransform: "uppercase",
                            letterSpacing: "0.6px",
                        } }, col)))),
                    chargeDays.map((day, index) => {
                        var _a;
                        const p = COD_PALETTE[index];
                        const desc = COD_LABELS[index];
                        const isLastRow = index === chargeDays.length - 1;
                        return (React.createElement(React.Fragment, { key: day },
                            React.createElement(Box, { sx: {
                                    display: "grid",
                                    gridTemplateColumns: "minmax(220px,1fr) 190px 160px 100px",
                                    alignItems: "center",
                                    px: 2.5,
                                    py: 1.6,
                                    bgcolor: index % 2 !== 0 ? "#FAFBFC" : "#fff",
                                    transition: "background-color 0.12s",
                                    "&:hover": { bgcolor: "rgba(244,162,97,0.04)" },
                                } },
                                React.createElement(Box, { sx: { display: "flex", alignItems: "center", gap: 1.75 } },
                                    React.createElement(Box, { sx: {
                                            display: "inline-flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            minWidth: 50,
                                            height: 26,
                                            px: 1.25,
                                            bgcolor: p.bg,
                                            border: `1px solid ${p.ring}`,
                                            borderRadius: "6px",
                                            flexShrink: 0,
                                        } },
                                        React.createElement(Typography, { sx: { fontFamily: "Poppins", fontWeight: 700, fontSize: "12px", color: p.label, letterSpacing: "0.02em" } }, day)),
                                    React.createElement(Box, null,
                                        React.createElement(Typography, { sx: { fontFamily: "Poppins", fontWeight: 600, fontSize: "13px", color: "#111827", lineHeight: 1.3 } }, desc.title),
                                        React.createElement(Typography, { sx: { fontFamily: "Poppins", fontSize: "11px", color: "#9CA3AF", mt: 0.1, lineHeight: 1.4 } }, desc.hint))),
                                React.createElement(Box, null,
                                    React.createElement(OutlinedInput, { size: "small", value: (_a = earlyCODCharges[index]) !== null && _a !== void 0 ? _a : "", onChange: (e) => handleChargeChange(index, e.target.value), placeholder: "0.00", inputProps: { inputMode: "decimal" }, sx: Object.assign(Object.assign({}, inputSx("#F4A261")), { width: 150 }), endAdornment: React.createElement(InputAdornment, { position: "end" },
                                            React.createElement(Typography, { sx: { fontFamily: "Poppins", fontSize: "13px", color: "#9CA3AF", lineHeight: 1 } }, "%")) })),
                                React.createElement(Typography, { sx: { fontFamily: "Poppins", fontSize: "12px", color: "#6B7280" } }, "% of COD amount"),
                                React.createElement(Box, { sx: {
                                        display: "inline-flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        height: 22,
                                        px: 1.1,
                                        bgcolor: "#F3F4F6",
                                        border: "1px solid #E5E7EB",
                                        borderRadius: "5px",
                                        width: "fit-content",
                                    } },
                                    React.createElement(Typography, { sx: { fontFamily: "Poppins", fontSize: "10.5px", fontWeight: 600, color: "#6B7280" } }, "+ GST"))),
                            !isLastRow && React.createElement(Divider, { sx: { borderColor: "#F3F4F8" } })));
                    }),
                    React.createElement(Box, { sx: {
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            px: 2.5,
                            py: 1.4,
                            bgcolor: "#F9FAFB",
                            borderTop: "1px solid #EDEEF3",
                        } },
                        React.createElement(InfoOutlinedIcon, { sx: { fontSize: 13, color: "#C4C7D2", flexShrink: 0 } }),
                        React.createElement(Typography, { sx: { fontFamily: "Poppins", fontSize: "11px", color: "#9CA3AF", lineHeight: 1.5 } }, "Blank fields fall back to the platform default rate. Charges are applied on the gross COD amount and are exclusive of GST.")))))));
};
export default VasChargesForm;
